import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import SharedGridPage from "./SharedGridPage";
import AddEditMcpServer from "../components/mcpServers/AddEditMcpServer/AddEditMcpServer";

const ManageMcpServer: FC = () => {
    const { t } = useTranslation();
    const { mcpServerId } = useParams();

    return (
        <SharedGridPage
            title={mcpServerId ? t("McpServer.EditServer") : t("McpServer.AddServer")}
            subComponent={<AddEditMcpServer />}
        />
    );
};

export default ManageMcpServer;
